import type { WorkspaceRole } from '@/features/workspace/types';

// Seul rôle encore attribuable : le rôle « Utilisateur » n'est plus proposé.
export const ASSIGNABLE_WORKSPACE_ROLE: WorkspaceRole = 'ADMIN';

// Le back renvoie encore USER sur les membres antérieurs à la simplification des rôles :
// on les lit comme des ADMIN tant que la migration n'a pas eu lieu.
export function normalizeWorkspaceRole(role: WorkspaceRole | undefined | null): WorkspaceRole {
  return role === 'ADMIN' ? 'ADMIN' : ASSIGNABLE_WORKSPACE_ROLE;
}
